export function initFileDeleteModal() {
    const modal = document.getElementById('deleteFileModal');
    if (!modal) return;

    modal.addEventListener('show.bs.modal', (event) => {
        const trigger = event.relatedTarget;
        const form = modal.querySelector('.delete-file-form');
        const fileName = modal.querySelector('[data-file-name]');
        const submitButton = form?.querySelector('[type="submit"]');
        const deleteUrl = trigger?.dataset.deleteUrl || '';

        if (form && deleteUrl) form.action = deleteUrl;
        if (form && !deleteUrl) form.removeAttribute('action');
        if (submitButton) submitButton.disabled = !deleteUrl;
        if (fileName) fileName.textContent = trigger?.dataset.file || '';
    });
}
